import {
  successNotifier,
  errorNotifier,
} from '../../../components/NotificationHandler';
import http, { AUTH_ROUTES } from '../../../services/api';

export const createEmergency = async (payload, setLoading, onClose) => {
  try {
    setLoading(true);
    const {
      data: { result },
    } = await http.post(AUTH_ROUTES.CREATE_EMERGENCY, payload);
    console.log('emergency data', result);
    setLoading(false);
    successNotifier(result.message);
    onClose();
  } catch (e) {
    console.log(e.response);
    errorNotifier(e.response.data.message);
    setLoading(false);
  }
};
